import { useEffect, useState } from 'react';
import { isNil } from 'lodash';
import stateList from "../data/state.json";

const useStatesList = (country) => {
    const [statesOpt, setStatesOpt] = useState<any>();

    // retrieve states list from json based on selected country
    useEffect(() => {
        if (isNil(country)) setStatesOpt([]);
        else {
            let states: any = [];
            stateList.map(state => {
                if (country === state.CountryCode) {
                    states.push({ value: state.Name, label: state.Name })
                }
            });
            setStatesOpt(states);
        }
    }, [country]);

    return statesOpt || [];
}

export default useStatesList